/**
 * en-GB messages added by Phase 2 task X1 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const x1EnGB = {};
//# sourceMappingURL=x1.js.map